import React, {useState, useContext, useEffect} from 'react';
import { useHistory } from "react-router-dom";

import consumoContext from '../../../context/consumos/consumoContext';
//import proyectoContext from '../../../context/proyectos/proyectoContext';

const EditarConsumo = () => {

    const history = useHistory();

    // state para recibir los datos modificados    
    const [consumo, setConsumo] = useState({
        nombre: '',
        potencia: 0,
        uso: 0,
        consumoE: 0,
        proyectoId: 0
    })

    // obtener el state de consumo
    const consumosContext = useContext(consumoContext);
    const { consumoeditar, actualizarConsumo } = consumosContext;

    const { nombre, potencia, uso } = consumo;

    // extraer si un proyecto esta activo
    //const proyectosContext = useContext(proyectoContext);
    //const { proyecto } = proyectosContext;
    // Array destructuring para extraer el proy actual
    //const [proyectoActual] = proyecto;
    
    // llenar el state automaticamente
    useEffect(() => {
        setConsumo(consumoeditar);
    }, [consumoeditar]);
    
    // leer los datos del formulario
    const onChangeFormulario = e => {
        
        setConsumo({
            ...consumo,
            [e.target.name] : e.target.value
            
        });    
    }
    
    const submitEditarConsumo = e => {
        e.preventDefault();

        // consumo = potencia x horas uso
        const {potencia, uso} = consumo;        
        consumo.consumoE = potencia*uso;
        //console.log(consumo);
        actualizarConsumo(consumo);
        //obtenerConsumosPyt(proyectoActual._id);
        
        history.push('/proyectos/consumos');
    }

    return (  
        <div className="row justify-content-center">
            <div className="col-md-6">
                <form
                    onSubmit={submitEditarConsumo}
                >
                    <fieldset>
                        <legend><h2>Actualice los datos</h2></legend>                
                        <div className="form-group">
                            <label for="aparato">Nombre Electrodoméstico</label>
                            <input 
                                type="text" 
                                className="form-control consumotxt" 
                                id="aparato" 
                                aria-describedby="aparato" 
                                placeholder="Nombre Electrodoméstico"
                                name="nombre"
                                value={ nombre }
                                onChange={onChangeFormulario}
                            />
                            <small id="ayudaaparato" className="form-text text-muted">Nombre, marca, o cualquier descripción que desee</small>
                        </div>
                        <div className="form-group">
                            <label for="potencia">Potencia en Watts</label>
                            <input 
                                type="number" 
                                className="form-control consumotxt" 
                                id="potencia" 
                                aria-describedby="potencia" placeholder="Potencia del electrodoméstico"
                                name="potencia" 
                                value={ potencia }
                                onChange={onChangeFormulario}
                            />
                            <small id="ayudaaparato" className="form-text text-muted">Este dato se encuentra generalmente en la parte posterior del aparato</small>
                        </div>
                        <div className="form-group">
                            <label for="uso">Uso diario del Electrodoméstico en horas</label>
                            <input 
                                type="number" 
                                className="form-control consumotxt" 
                                id="uso" 
                                aria-describedby="uso" 
                                placeholder="Tiempo de uso del aparato"
                                name="uso" 
                                value={ uso }
                                onChange={onChangeFormulario}
                                />
                            <small id="ayudaaparato" className="form-text text-muted">Tiempo que a diario se utiliza el electrodoméstico</small>
                        </div>                
                        <button type="submit" className="btn btn-primary text-uppercase">Guardar Cambios</button>
                    </fieldset>
                </form>
            </div>
        </div>
    );
}
 
export default EditarConsumo;